export default {
  REWARDS: "रिवार्ड्स",
  REWARD: "रिवार्ड",
  DAILYCHECKINREWARD: "डेली चेक-इन रिवार्ड",
};
